import { focusOutlineWidth, HighContrastColor, highContrastSelector, neutralForegroundRest, } from "@fast/fast-components-styles-msft";
import { directionSwitch, format, toPx } from "@fast/fast-jss-utilities";
const styles = {
    article: {
        position: "relative",
        overflow: "hidden",
        display: "grid",
        "grid-template-columns": "1fr auto",
        "column-gap": "16px",
        color: neutralForegroundRest,
    },
    article_heading: {
        "font-weight": "600",
        "text-decoration": "none",
        color: neutralForegroundRest,
        "font-size": "16px",
        "line-height": "24px",
        overflow: "hidden",
        display: "-webkit-box",
        "-webkit-line-clamp": "3",
        "-webkit-box-orient": "vertical",
        margin: "0",
        outline: "0",
        [highContrastSelector]: {
            color: HighContrastColor.forcedColorLink,
            "&:hover": {
                "text-decoration": "underline",
            },
        },
        "&:focus": {
            "text-decoration": "underline",
        },
        "&::after": {
            content: "''",
            position: "absolute",
            top: "calc(-100% + 48px)",
            bottom: "0",
            right: "0",
            left: "0",
            width: "100%",
            "z-index": "1",
        },
    },
    article_abstract: {
        overflow: "hidden",
        display: "-webkit-box",
        "-webkit-line-clamp": "3",
        "-webkit-box-orient": "vertical",
        "font-weight": "400",
        "font-size": "14px",
        "line-height": "20px",
        "font-kerning": "auto",
        margin: "0",
        opacity: "0.8",
        [highContrastSelector]: {
            opacity: "1",
        },
    },
    article__card: {
        width: "100%",
        height: "100%",
        position: "relative",
        overflow: "visible",
        "grid-template-columns": "none",
        display: "block",
        "&:hover": {
            "& $article_hideStory": {
                opacity: "1",
            },
            "& $article_image": {
                opacity: 0.5,
            },
        },
        "& $article_heading, $article_attribution": {
            color: neutralForegroundRest,
            "margin-bottom": "8px",
        },
        "& $article_image": {
            position: "absolute",
            display: "block",
            "max-width": "100%",
            top: "0",
            right: directionSwitch("0", undefined),
            left: directionSwitch(undefined, "0"),
            transition: "opacity 0.1s linear",
            "& > img": {
                "max-width": "100%",
            },
        },
        "& $article_text": {
            position: "absolute",
            bottom: "0",
            "z-index": "1",
            padding: "24px 16px 16px 16px",
            "box-sizing": "border-box",
            width: "100%",
        },
        "& $article_gradient": {
            position: "absolute",
            top: "-55px",
            bottom: "79px",
            left: "0",
            right: "0",
            "z-index": "-1",
        },
        "& $article_actions": {
            position: "relative",
            display: "flex",
            "justify-content": "space-between",
            "align-items": "center",
        },
        "& $article_hideStoryWrapper": {
            position: "absolute",
            display: "flex",
            "flex-direction": "row",
            top: "16px",
            right: directionSwitch("0", undefined),
            left: directionSwitch(undefined, "0"),
            "z-index": "2",
            "& $article_hideStory": {
                width: "96px",
                height: "96px",
                top: "-32px",
                right: directionSwitch("-16px", "unset"),
                left: directionSwitch("unset", "-16px"),
                position: "absolute",
                display: "flex",
                "justify-content": "center",
                "align-items": "center",
                opacity: "0",
                transition: "opacity 0.1s linear",
                "& > button": {
                    display: "flex",
                    "justify-content": "center",
                    "align-items": "center",
                    position: "relative",
                    outline: "none",
                    "min-height": "32px",
                    "min-width": "32px",
                    "background-color": "transparent",
                    color: neutralForegroundRest,
                    fill: "currentcolor",
                    cursor: "pointer",
                    "border-radius": "100%",
                    border: format("{0} solid {1}", toPx(focusOutlineWidth), neutralForegroundRest),
                    width: "32px",
                    height: "32px",
                    "&:hover": {
                        "background-color": "rgba(255, 255, 255, 0.17)",
                        [highContrastSelector]: {
                            "background-color": HighContrastColor.selectedBackground,
                            "border-color": HighContrastColor.buttonText,
                            fill: HighContrastColor.selectedText,
                        },
                    },
                    "&:focus": {
                        "background-color": "rgba(255, 255, 255, 0.17)",
                        [highContrastSelector]: {
                            "background-color": HighContrastColor.selectedBackground,
                            "border-color": HighContrastColor.buttonText,
                            fill: HighContrastColor.selectedText,
                        },
                    },
                    [highContrastSelector]: {
                        "background-color": HighContrastColor.buttonBackground,
                    },
                },
            },
        },
    },
    article__card_focusWithin: {
        "& $article_hideStoryWrapper": {
            "& $article_hideStory": {
                opacity: "1",
            },
        },
        "& $article_image": {
            opacity: 0.5,
        },
    },
    article_startActions: {
        "z-index": "2",
    },
    article_endActions: {
        "z-index": "2",
    },
    article__card_noImage: {
        "& $article_gradient": {
            bottom: "0",
        },
        "& $article_text": {
            height: "100%",
            bottom: "initial",
        },
        "& $article_attribution": {
            "margin-bottom": "40px",
        },
        "& $article_actions": {
            position: "absolute",
            bottom: "16px",
            width: "calc(100% - 32px)",
        },
    },
    article__wide: {
        "& $article_gradient": {
            position: "absolute",
            left: directionSwitch("0", "-120px"),
            right: directionSwitch("-120px", "0"),
            bottom: "0",
        },
        "& $article_text": {
            height: "100%",
            width: "50%",
        },
        "& $article_attribution": {
            "margin-bottom": "40px",
        },
        "& $article_actions": {
            position: "absolute",
            bottom: "16px",
            width: "calc(100% - 32px)",
        },
        "& $article_heading": {
            "&::after": {
                right: directionSwitch("-100%", undefined),
                left: directionSwitch(undefined, "-100%"),
                width: "200%",
            },
        },
    },
    article__wide_noImage: {
        "& $article_gradient": {
            right: directionSwitch("-310px", "0"),
            left: directionSwitch("0", "-310px"),
            bottom: "0",
        },
        "& $article_text": {
            width: "100%",
        },
    },
    article__wide_imageStart: {
        "& $article_gradient": {
            position: "absolute",
            right: directionSwitch("0", "-120px"),
            left: directionSwitch("-120px", "0"),
            bottom: "0",
        },
        "& $article_image": {
            right: directionSwitch(undefined, "0"),
            left: directionSwitch("0", undefined),
        },
        "& $article_text": {
            right: directionSwitch("0", undefined),
            left: directionSwitch(undefined, "0"),
        },
        "& $article_heading": {
            "&::after": {
                right: directionSwitch(undefined, "-100%"),
                left: directionSwitch("-100%", undefined),
            },
        },
        "& $article_hideStoryWrapper": {
            right: directionSwitch("unset", "63px"),
            left: directionSwitch("63px", "unset"),
            "& $article_hideStory": {
                right: directionSwitch("-16px", "unset"),
                left: directionSwitch("unset", "-16px"),
            },
        },
    },
    article_hideStoryWrapper: {},
    article_actions: {},
    article_text: {},
    article_gradient: {},
    article_hideStory: {},
    article_image: {},
    article_attribution: {},
};
export default styles;
